<template>
    <div class="bg-0A1129 text-white min-vh-100">
        <!-- Main Header -->
        <Mainlayout />
    
        <div class="container-fluid pt-5">
            <br /> <br /> <br />
            <div class="row p-3">
    
                <div class="col-md-12">
                    <h3 class="custom-32px-700 text-center">Kursus FlyHigh</h3>
                    <h4 class="custom-24px-400 mb-3">Temukan pelbagai kursus yang sesuai dengan minat anda</h4>
                    <CCol sm="12" class="mt-5">
                        <CRow class="">
                            <CCol sm="5" class="p-0">
                                <div class="position-relative">
                                    <img src="../assets/img/search-normal.png" class="search-icon" />
                                    <CInput type="text" placeholder="Search..." class="custom-input-black pl-5" style="background:none;border:none" />
                                </div>
    
                            </CCol>
                            <CCol sm="2" class="p-0">
                                <CButton type="button" class="bg-1796FD text-white ml-2 mt-2">Cari</CButton>
                            </CCol>
                        </CRow>
                        <div class="d-flex align-items-center justify-content-between flex-wrap mb-4">
                            <div class="d-flex align-items-center flex-wrap gap-2">
                                <span class="text-white mr-3">Paling popular:</span>
                                <span v-for="(subject, index) in subjects" :key="index" class="badge badge-pill px-3 py-2 text-white m-2" style="background-color: #101C46; font-weight: 500;">
                                    {{ subject }}
                                    </span>
                            </div>
                            <div class="d-flex gap-2 mt-2 mt-md-0">
                                <button class="btn text-white px-3" style="background-color: #101C46; border-radius: 30px;">
                                    ← Sebelumnya
                                    </button>
                                <button class="btn text-white px-3" style="background-color: #101C46; border-radius: 30px;">
                                    Seterusnya →
                                    </button>
                            </div>
                        </div>
                    </CCol>
                    <h4 class="mb-3 mt-5">Sedang Promosi!</h4>
    
                    <div class="row">
                        <div class="col-md-4 mb-4" v-for="(course, index) in courses" :key="index">
                            <div class="border-card-black text-dark border-24px p-0">
                                <img :src="course.PicturePath" class="card-img-top border-half-24px" alt="Course Image"  style="height: 250px; width: 100%; object-fit: cover;">
                                <div class="p-3">
                                    <h5 class="text-white">{{ course.Title }} (x{{ course.Quantity || 1 }})</h5>
                                    <h3 class="custom-16px-400 text-white">{{ course.DateCourse |moment("DD MMM") }} - 08.00 PM</h3>
                                        <p>
                                        <del v-if="course.Price" class="font-color-1796FD custom-18px-500">RM {{ course.Price }}</del>
                                        <strong v-if="course.Price && course.Discount" class="text-white custom-18px-600">
                                            RM {{ (course.Price - course.Discount) * (course.Quantity || 1) }}
                                        </strong>
                                        </p>

                                    
                                </div>
                                <div style="clear:both"></div>
                                <CCol sm="12" class="mb-2">
                                    <CRow>
                                        <CCol sm="8">
                                           <h3 class="custom-16px-600 text-white">0 students purchased</h3>
                                        </CCol>
                                        <CCol sm="4">
                                            <CButton class="bg-1796FD custom-padding text-white" style="border-radius:50px" @click="GoToDetail(course)">Add To Cart</CButton>

                                        </CCol>
                                    </CRow>
                                </CCol>
    
    
    
                            </div>
                        </div>
                    </div>
                </div>
    
    
    
            </div>
        </div>
    
        <!-- Footer -->
        <Footer />
    </div>
</template>
  
<script>
import Vue from "vue";
Vue.use(Carousel3d);
import Mainlayout from "@/containers/AllHeader.vue";
import Footer from "@/components/Footer.vue";
import { Carousel3d, Slide } from "vue-carousel-3d";
import ToggleCard from '../components/Toggle.vue';
Vue.use(require("vue-moment"));
Vue.use(require("moment"));
var moment = require("moment");

export default {
    name: "FlyHighHome",
    components: {
        Mainlayout,
        Footer,
        Carousel3d,
        Slide,
        moment

    },
    async mounted() {


        this.GetListPackage();

    },
    data() {
        return {
            step: 1,
            grades: [
                "Tingkatan 1", "Tingkatan 2", "Tingkatan 3",
                "Tingkatan 4", "Tingkatan 5", "Tahap 1",
                "Tahap 2", "Menengah Bawah", "Menengah Atas", "Terbuka"
            ],
            subjects: [
                "Bahasa Melayu", "Matematik", "Sains",
                "UPKK", "PSRA", "UKKM",
            ],
            courses: [],
            banners: [
                { src: require('@/assets/img/flyhigh/banner1.png') },
                { src: require('@/assets/img/flyhigh/banner2.png') },
            ],
            isProductOpen: false,
            grade: [],
            isJenisOpen: true,
            isStandardOpen: true,
            isSubjekOpen: true,
            selectedType: 'combo',
            showFilterOptions: false,
        };
    },
    computed: {
        sliderStyle() {
            let slidesPerView = 1; // Default for mobile

            if (window.innerWidth >= 768 && window.innerWidth < 1024) {
                slidesPerView = 2; // Tablet (2 per slide)
            } else if (window.innerWidth >= 1024) {
                slidesPerView = 2; // Desktop (3 per slide)
            }

            return {
                transform: `translateX(-${(this.step - 1) * (100 / slidesPerView)}%)`,
                transition: 'transform 0.5s ease-in-out'
            };
        },
    },

    methods: {
        nextSlide() {
            if (this.step < this.banners.length) {
                this.step++;
            }
        },
        prevSlide() {
            if (this.step > 1) {
                this.step--;
            }
        },
        goToStep(index) {
            this.step = index;
        },
        toggleProductList() {
            this.isProductOpen = !this.isProductOpen;
        },
        // GoToDetail() {
        //     this.$router.push("DetailProduct");
        // },
        toggleJenisList() {
            this.isJenisOpen = !this.isJenisOpen;
        },
        toggleStandardList() {
            this.isStandardOpen = !this.isStandardOpen;
        },
        toggleSubjekList() {
            this.isSubjekOpen = !this.isSubjekOpen;
        },
        toggleFilterOptions() {
            this.showFilterOptions = !this.showFilterOptions;
        },
        GetListPackage() {
            this.$API
                .get(this.$GetListProduct)
                .then((response) => {
                    if (response.status == 200 && response.data != null) {
                        this.courses = response.data;
                    }
                });
        },
        GoToDetail(course) {
            if (!course || !course.Title) {
                console.warn("Invalid course clicked:", course);
                return;
            }

            let cartItem = {
                ID: course.ID,
                Title: course.Title,
                PicturePath: course.PicturePath,
                Price: course.Price,
                Discount: course.Discount,
            };

            let existing = JSON.parse(localStorage.getItem("cartItems")) || [];

            let found = existing.find(item => item.ID === course.ID);
            if (found) {
            found.Quantity = (found.Quantity || 1) + 1;
            } else {
            existing.push({
                ID: course.ID,
                Title: course.Title,
                PicturePath: course.PicturePath,
                Price: course.Price,
                Discount: course.Discount,
                Quantity: 1
            });
            }

            localStorage.setItem("cartItems", JSON.stringify(existing));
            this.$router.push("ShoppingCart");
        }
    }
}
</script>
  
<style scoped>
.slider-wrapper {
    overflow: hidden;
    width: 100%;
}

.slider {
    display: flex;
    transition: transform 0.5s ease-in-out;
    white-space: nowrap;
    align-items: stretch;
    /* Ensures all slides have the same height */
}

.slide::before {
    display: none !important;
}

.slide {
    min-width: 100%;
    padding: 10px;
    transition: opacity 0.5s, transform 0.5s;
    height: 100%;
    /* Ensure all slides remain the same height */
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: relative;
    z-index: 10;
    opacity: 1 !important;
}

@media (min-width: 1024px) {
    .slide {
        min-width: calc(100% / 3);
        /* Each slide takes 1/3 of the container */
    }
}

@media (min-width: 768px) and (max-width: 1023px) {
    .slide {
        min-width: 50%;
        /* Show 2 items per slide */
    }
}

.active-slide {
    opacity: 1;
    transform: scale(1);
    /* Ensure the active slide does not change in size */
}

.slide:not(.active-slide) {
    opacity: 0.6;
    /* Dim non-active slides */
    transform: scale(1);
    /* Keep all slides the same size */
}

.image-container {
    position: relative;
    width: 100%;
    height: 100%;
    /* Ensure the image container takes full height */
    display: flex;
    flex-direction: column;
    justify-content: center;
}

.onboarding-image {
    width: 100%;
    /* Make all images the same height */
    border-radius: 10px;
    object-fit: cover;
    /* Ensures the image maintains proportion */
}

.overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    /* Dark overlay */
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    padding: 20px;
    border-radius: 10px;
    color: white;
}

.pagination {
    display: flex;
    justify-content: center;
    gap: 5px;
}

.pagination span {
    width: 10px;
    height: 10px;
    background: #ccc;
    border-radius: 50%;
    cursor: pointer;
    transition: background 0.3s;
}

.pagination span.active {
    background: #fff;
}

.nav-arrow {
    position: absolute;
    top: 17%;
    transform: translateY(-50%);
    background-color: rgba(0, 0, 0, 0.4);
    color: white;
    font-size: 1.2rem;
    /* smaller font size */
    border: none;
    cursor: pointer;
    z-index: 10;
    padding: 0.3rem 0.6rem;
    /* smaller padding */
    border-radius: 50%;
    width: 30px;
    height: 30px;
    line-height: 1;
    display: flex;
    align-items: center;
    justify-content: center;
}

.left-arrow {
    left: 10px;
}

.right-arrow {
    right: 10px;
}

.nav-arrow:hover {
    background-color: rgba(0, 0, 0, 0.6);
}

.list-group-item {
    transition: all 0.3s;
}

.toggle-icon {
    width: 20px;
    height: 20px;
}

.list-group-item img {
    width: 18px;
    height: 18px;
}
</style>